export class Driver {
    id: number;
    identification: string;
    name: string;
    phone: string;
    vehicle_plate: string;
    type: string;
    email: string;
    status: string;
    createdAt: string;
    updatedAt: string;
}